export class FollowerProjectStatusLog {
  id: number;
  oldStatus: string;
  newStatus: string;
  changedByUserType: string;
  changedByUsername: string;
  changedAt: Date;
}
